import { Instagram, Phone, Mail, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND, NAV } from "../../content/site";
import { scrollToId } from "../../lib/scroll";
import { Logo } from "./Logo";

const SOCIAL = [
  { icon: Instagram, href: BRAND.instagramUrl, label: "Instagram" },
  { icon: MessageCircle, href: BRAND.whatsapp, label: "WhatsApp" },
  { icon: Phone, href: BRAND.phoneHref, label: "Call" },
  { icon: Mail, href: `mailto:${BRAND.email}`, label: "Email" },
];

export const Footer = () => (
  <footer className="relative overflow-hidden bg-ink-dark px-5 pb-28 pt-20 text-cream sm:px-8 lg:px-16 lg:pb-10" data-testid="site-footer">
    <div className="mx-auto max-w-[1300px]">
      <p className="font-script text-5xl text-gold-light sm:text-7xl lg:text-8xl">{BRAND.heroLine}</p>
      <div className="mt-14 grid gap-12 border-t border-cream/15 pt-12 md:grid-cols-3">
        <div>
          <Logo light />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-cream/80">{BRAND.tagline}. {BRAND.location}.</p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-gold-light">Quick links</p>
          <ul className="mt-5 grid grid-cols-2 gap-y-3">
            {NAV.map((n) => (
              <li key={n.id}>
                <button onClick={() => scrollToId(n.id)} className="text-sm text-cream/85 transition-colors hover:text-gold-light" data-testid={`footer-link-${n.id}`}>{n.label}</button>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-gold-light">Say hello</p>
          <a href={BRAND.phoneHref} className="mt-5 block font-serif text-2xl" data-testid="footer-phone">{BRAND.phone}</a>
          <a href={`mailto:${BRAND.email}`} className="mt-1 block break-all text-sm text-cream/85" data-testid="footer-email">{BRAND.email}</a>
          <div className="mt-6 flex gap-3">
            {SOCIAL.map(({ icon: Icon, href, label }) => (
              <a key={label} href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" aria-label={label} className="grid h-11 w-11 place-items-center rounded-full border border-cream/25 transition-colors duration-300 hover:border-gold-light hover:bg-gold-light hover:text-ink-dark" data-testid={`footer-social-${label.toLowerCase()}`}>
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-14 flex flex-col gap-3 border-t border-cream/15 pt-6 text-xs text-cream/70 sm:flex-row sm:justify-between">
        <p data-testid="footer-copyright">© 2026 Glow Motion Pictures. All rights reserved.</p>
        <Link to="/admin/login" className="hover:text-cream" data-testid="footer-admin-link">Studio login</Link>
      </div>
    </div>
  </footer>
);
